import { render, staticRenderFns } from "./TaskConfiguration.vue?vue&type=template&id=5f1a2fd3&"
import script from "./TaskConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TaskConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports